var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 16,
    fill: "#fff",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.772 3.575h2.797L10.772.78v2.795zm-.308 11.229v-.99H4.583c-.461-.001-.904-.184-1.23-.51a1.74 1.74 0 0 1-.51-1.23v-8.81H1.231a.9.9 0 0 0-.898.898v10.643a.9.9 0 0 0 .898.898h8.335a.9.9 0 0 0 .898-.898h0zM9.93 3.997V.533H4.583a.9.9 0 0 0-.898.898v10.643a.9.9 0 0 0 .898.898h8.335a.9.9 0 0 0 .898-.898V4.418h-3.465a.42.42 0 0 1-.421-.421h0z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/Copy.32d71b96fb6b41389c721e6b1774d1d7.svg";
export { ForwardRef as ReactComponent };